import type { Language } from '../stores/ui.store';

/** El idioma con que arranca la app: el del seminario (`config.locale`), para
 *  TODOS los seminarios desde M4·D1 (antes, solo con `graduation_audit`).
 *  `null` = no tocar nada: el usuario ya eligió su idioma, o el seminario no
 *  declara uno (queda el idioma por defecto de la app). Una elección explícita
 *  siempre gana.
 *
 *  LAS REDES (`config.isNetwork`, hoy tmai-network) QUEDAN FUERA: se comportan
 *  como antes de M4·D1, o sea solo si llevan el expediente por credenciales
 *  (antes, la bandera `graduation_audit`, retirada en el paso 5 de D1). Una red
 *  no es un seminario, y su `locale` no se decidió pensando en quien entra a
 *  revisar. */
export function tenantInitialLanguage(input: {
  languageExplicit: boolean;
  locale: string | null;
  isNetwork: boolean;
  credentialRecord: boolean;
}): Language | null {
  if (input.languageExplicit || !input.locale) return null;
  if (input.isNetwork && !input.credentialRecord) return null;
  return input.locale.toLowerCase().startsWith('en') ? 'en' : 'es';
}
